import { Component, OnInit, HostListener, Output, EventEmitter } from '@angular/core';
import { Order } from '@app/services/order/order.model';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';

@Component({
  selector: 'scan-multiple-options',
  templateUrl: './scan-multiple-options.html',
  styleUrls: ['./scan-multiple-options.scss'],
  standalone: false,
})
export class ScannedOrderMultipleResults implements OnInit {
  @Output() onClose = new EventEmitter<Event>();
  @Output() onSelect = new EventEmitter<string>();
  orders: Order[] = [];
  ordersSplitIndices = {};

  constructor() {}

  ngOnInit(): void {
    this.orders.forEach((order) => {
      this.ordersSplitIndices[order.id] = getOrderSplitIndicesString(order, 'view');
    });
  }

  onOrderSelect(order) {
    this.onSelect.emit(order);
  }

  @HostListener('document:click', ['$event.target'])
  click(target) {
    if (!target.closest('pdq-button')) {
      this.onClose.emit();
    }
  }
}
